var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.667 512.667",
    height: 512,
    viewBox: "0 0 512.667 512.667",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256.333 145.259c52.164-32.661 71.196-58.979 71.196-81.373 0-22.438-18.19-40.627-40.628-40.627-12.192 0-23.121 5.378-30.568 13.882-7.447-8.504-18.376-13.882-30.568-13.882-22.438 0-40.628 18.189-40.628 40.627.001 22.394 19.032 48.712 71.196 81.373z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.5 351.783c0-25.153 11.285-47.708 29.041-62.912-18.191-14.889-41.421-23.838-66.707-23.838h-30.334c-58.173 0-105.5 47.327-105.5 105.5v118.875h157.669c4.624-30.542 23.141-56.586 48.886-71.465-20.06-15.131-33.055-39.154-33.055-66.16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.333 434.617c-33.334 0-61.286 23.494-68.169 54.791h136.338c-6.882-31.297-34.834-54.791-68.169-54.791z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m407.167 298.95h-30.333c-17.499 0-34.004 4.302-48.547 11.875 6.909 12.09 10.88 26.065 10.88 40.958 0 27.006-12.995 51.029-33.055 66.16 25.745 14.879 44.262 40.923 48.886 71.465h157.669v-84.958c0-58.173-47.327-105.5-105.5-105.5z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 392,
    cy: 199.158,
    rx: 69.792,
    ry: 69.791,
    transform: "matrix(.995 -.099 .099 .995 -17.717 39.596)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.667,
    cy: 165.242,
    rx: 69.792,
    ry: 69.792,
    transform: "matrix(.924 -.383 .383 .924 -54.05 58.756)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256.333 298.95c-29.132 0-52.833 23.701-52.833 52.833 0 29.133 23.701 52.834 52.833 52.834s52.833-23.701 52.833-52.834c.001-29.132-23.7-52.833-52.833-52.833z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.5a9a4192cfa1113208804ee427ced564.svg";
export { ForwardRef as ReactComponent };